<template>
  <div>
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <i class="el-icon-message-solid"></i> 语音播报
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="container" style="min-width:500px">
      <div style="width:500px;position: relative;">
        <div style="margin-bottom: 20px;">
          <el-radio v-model="radio" label="1">老版本</el-radio>
          <el-radio v-model="radio" label="2">新版本</el-radio>
        </div>
        <div v-show="radio=='1'">
          <el-form :model="voicefrom" ref="voicefrom2" label-width="100px" :rules="rules">
            <el-form-item label="sn号" prop="sn">
              <el-input class="ovicefrominput" v-model="voicefrom.sn"></el-input>
            </el-form-item>
            <el-form-item label="token" prop="token">
              <el-input class="ovicefrominput" v-model="voicefrom.token"></el-input>
            </el-form-item>
            <el-form-item label="version" prop="version">
              <el-input class="ovicefrominput" v-model.number="voicefrom.version"></el-input>
            </el-form-item>
          </el-form>
          <div class="dialog-bottom">
            <el-button type="primary" @click="modifyVoice">修改</el-button>
          </div>
        </div>
        <div v-show="radio=='2'">
          <div class="addBut">
            <el-button class="mr30" circle type="primary" icon="el-icon-plus" @click="addEquipment()">
            </el-button>
            <el-popover placement="top" width="150" v-model="popoverVisible">
              <p>确定要移除吗？</p>
              <div style="text-align: right; margin: 0">
                <el-button size="mini" type="text" @click="popoverVisible = false">取消</el-button>
                <el-button type="primary" size="mini" @click="removeEquipment()">确定</el-button>
              </div>
              <el-button slot="reference" circle type="primary" icon="el-icon-minus"></el-button>
            </el-popover>
          </div>
          <el-form ref="newvoiceformref" :model="newvoiceform" label-width="100px" :rules="rules2">
            <el-form-item v-for="(item,index) in newvoiceform.x_sn" :key="index" :label="'设备编号'+index" prop="x_sn">
              <el-input class="ovicefrominput" v-model="newvoiceform.x_sn[index]"></el-input>
            </el-form-item>
          </el-form>
          <div class="dialog-bottom">
            <el-button type="primary" @click="newversionInfo()">修改</el-button>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'voice',
    data() {
      return {
        query: {
          id: sessionStorage.getItem("merchants_id") ? sessionStorage.getItem("merchants_id") : '14',
          auth: '2',
          limit: 8,
          page: 1
        },
        voicefrom: {},
        newvoiceform: {
          x_sn:[]
        },
        rules: { //验证规则
          sn: [{
            message: '请输入sn号',
            required: true,
          }],
          token: [{
            type: 'string',
            message: '请输入token',
            required: true,
          }],
          version: [{
            type: 'number',
            message: '请输入version，必须是数字',
            required: true,
          }]
        },
        rules2: {
          x_sn: [{
            message: '请输入设备编号',
            required: true,
            trigger: 'blur'
          }]
        },
        popoverVisible: false,
        radio: '1'
      }
    },
    mounted() {
      this.getData();
    },
    methods: {
      getData() {
        let that = this
        let url = that.$apiUrl.merchant.getMerchant
        that.$post(url, that.$params(that.query)).then(res => {
          if (res.data.code == 200) {
            that.voicefrom =  Object.assign({},res.data.data.list[0])
            that.newvoiceform = Object.assign({},res.data.data.list[0])
            that.loading = false
          }
        }).catch(error => {
          that.loading = false
          this.$message.error(error)
        })
      },
      modifyVoice() {
        this.$refs['voicefrom2'].validate((valid) => {
          if (valid) {
            let url = this.$apiUrl.merchant.voicechant
            this.voicefrom.type = '1'; //type为1就是老版本
            delete this.voicefrom.x_sn;
            this.$post(url, this.$params(this.voicefrom)).then(res => {
              if (res.data.msg == "修改失败") {
                this.$message.error("修改失败")
              } else if (res.data.msg == "修改成功") {
                this.getData()
                this.$message.success("修改成功")
              }
            }).catch(error => {
              this.$message.error(error)
            })
          }
        })
      },
      //添加和移除多个设备
      addEquipment() {
        this.newvoiceform.x_sn.push(null)
      },
      removeEquipment() {
        this.newvoiceform.x_sn.pop();
        this.popoverVisible = false;
      },
      //新版本设备保存按钮回调
      newversionInfo() {
        let verification = true;
        let newvoiceform2 = Object.assign({}, this.newvoiceform);
        for (let item of newvoiceform2.x_sn) {
          if (item == null || item == undefined || item == '') {
            verification = false;
          }
        }

        if (verification) {
          let url = this.$apiUrl.merchant.voicechant;
          newvoiceform2.type = '2'; //type为2就是新版本
          newvoiceform2.x_sn = JSON.stringify(newvoiceform2.x_sn);
          delete newvoiceform2.sn
          this.$post(url, this.$params(newvoiceform2)).then(res => {
            console.log(res);
            if (res.data.code == 200) {
              this.$message.success("修改成功")
              this.getData()
            } else {
              this.$message.error("修改失败")
            }
          }).catch(error => {
            this.$message.error(error)
          })
        } else {
          console.log('设备不能为空');
          this.$message({
            showClose: true,
            message: '设备不能为空',
            type: 'warning'
          })
        }
      }
    },
    watch: {
      newvoiceform() {
        this.newvoiceform.x_sn = JSON.parse(this.newvoiceform.x_sn);
        if (this.newvoiceform.x_sn == null) {
          this.newvoiceform.x_sn = []
        }
      }
    }
  }
</script>

<style scoped>
  .ovicefrominput {
    width: 400px;
  }

  .addBut {
    position: absolute;
    top: 0;
    right: 20px;
  }

  .mr30 {
    margin-right: 10px;
  }
</style>